import React, { Component } from "react";
import Headers from "../Layouts/HeaderReceptionist";
import axios from "axios";
// import NextOfKin from './NextOfKin';
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { config } from "../_helpers/global";
import { NewbornSidebar } from "../Layouts/NewbornSidebar";

export class TreatmentCounselling extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      preNeoNatalTreatment: "",
      VitaminKinjection: "",
      tetracyclineeyeOintment: "",
      startedBreastfeedingat30minutes: "",
      breastfedingCounselling: "",
      hypothermiaKangarooCounselling: "",
      BCGgiven: "",
      OPVgiven: "",
      vaccinationCardCounselling: "",
      cordCareDangerSignsCounselling: "",
      outcomeStatus: "",
      BCDDateGiven: "",
      OPVDateGiven: "",
      loading: false,
      response: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    this.setState({
      uniqid: (Math.random() + 1).toString(36).substring(7),
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      "Access-Control-Allow-Origin": "*",
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    let payload = {
      preNeoNatalTreatment: this.state.preNeoNatalTreatment,
      VitaminKinjection: this.state.VitaminKinjection,
      tetracyclineeyeOintment: this.state.tetracyclineeyeOintment,
      startedBreastfeedingat30minutes:
        this.state.startedBreastfeedingat30minutes,
      breastfedingCounselling: this.state.breastfedingCounselling,
      hypothermiaKangarooCounselling: this.state.hypothermiaKangarooCounselling,
      BCGgiven: "(" + this.state.BCGgiven + "," + this.state.BCDDateGiven + ")",
      OPVgiven: "(" + this.state.OPVgiven + "," + this.state.OPVDateGiven + ")",
      vaccinationCardCounselling: this.state.vaccinationCardCounselling,
      cordCareDangerSignsCounselling: this.state.cordCareDangerSignsCounselling,
      outcomeStatus: this.state.outcomeStatus,
    };

    // console.log(payload);

    this.state.loading = true;
    axios
      .post(this.api_url+"newborn/counselling", payload, {
        headers: headers,
      })
      .then((response) => {
        this.state.loading = false;
        // console.log(response)
        this.setState({ response: response });
        if (response.status == 200) {
          $("#SubmitError").fadeOut("fast");
          $(".alert-success").show();
          setTimeout(function (props) {
            window.location.href = "/newbornunit/physical/examination";
          }, 1000);
        } else {
          $(".alert-success").fadeOut("fast");
          $("#SubmitError").show();
        }
      })
      .catch((error) => {
        this.state.loading = false;
        $(".alert-success").fadeOut("fast");
        $("#SubmitError").show();
        console.log(error);
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const {
      preNeoNatalTreatment,
      VitaminKinjection,
      tetracyclineeyeOintment,
      startedBreastfeedingat30minutes,
      breastfedingCounselling,
      hypothermiaKangarooCounselling,
      BCGgiven,
      OPVgiven,
      vaccinationCardCounselling,
      cordCareDangerSignsCounselling,
      outcomeStatus,
      BCDDateGiven,
      OPVDateGiven,
      loading,
    } = this.state;

    return (
      <div>
        {/* <NextOfKin userData = {response}/> */}
        <Headers />
        <NewbornSidebar></NewbornSidebar>

        <main className="content-container">
          <div className="container p-2">
            <div className="row pl-2 text-lg-center font-weight-bold p-1">
              <p className="text-capitalize" style={font16}>
                TREATMENT AND COUNSELLING
              </p>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Any other treatment given at maternity/OT before referral
                      to neonatal unit?
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={preNeoNatalTreatment}
                      name="preNeoNatalTreatment"
                      type="text"
                      rows="8"
                      required
                    ></textarea>
                  </div>
                  {/* <div className="py-1">
                                        <h6 className="text-capitalize">Date Of Birth</h6>
                                        <input className="form-control" name="dateofBirth" onChange={this.handleChange} value={dateofBirth} type="date" required />
                                    </div>
                                    <div className="py-1">
                                        <h6 className="text-capitalize">Time Of Birth (24 Hr Format)</h6>
                                        <input className="form-control" type="time" onChange={this.handleChange} value={timeofBirth} name="timeofBirth" />
                                    </div> */}
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Vitamin K injection:
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={VitaminKinjection}
                      name="VitaminKinjection"
                    >
                      <optgroup label="VitaminKinjection">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Tetracycline eye ointment:
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={tetracyclineeyeOintment}
                      name="tetracyclineeyeOintment"
                    >
                      <optgroup label="tetracyclineeyeOintment">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Started Breastfeeding at 30 minutes:{" "}
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={startedBreastfeedingat30minutes}
                      name="startedBreastfeedingat30minutes"
                    >
                      <optgroup label="startedBreastfeedingat30minutes">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Counselling about exclusive breastfeeding
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={breastfedingCounselling}
                      name="breastfedingCounselling"
                    >
                      <optgroup label="breastfedingCounselling">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Counselling about prevention of hypothermia or Kangaroo
                      Mother Care given:{" "}
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={hypothermiaKangarooCounselling}
                      name="hypothermiaKangarooCounselling"
                    >
                      <optgroup label="hypothermiaKangarooCounselling">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      BCG Vaccine Given:{" "}
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={BCGgiven}
                      name="BCGgiven"
                    >
                      <optgroup label="BCGgiven">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Date Given</h6>
                    <input
                      className="form-control"
                      name="BCDDateGiven"
                      onChange={this.handleChange}
                      value={BCDDateGiven}
                      type="date"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      OPV 0 Given: Yes /No:{" "}
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={OPVgiven}
                      name="OPVgiven"
                    >
                      <optgroup label="OPVgiven">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Date Given</h6>
                    <input
                      className="form-control"
                      name="OPVDateGiven"
                      onChange={this.handleChange}
                      value={OPVDateGiven}
                      type="date"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Counselling about vaccination and Vaccination Card Given:
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={vaccinationCardCounselling}
                      name="vaccinationCardCounselling"
                    >
                      <optgroup label="vaccinationCardCounselling">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Counselling about cord care and danger signs of newborn:
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={cordCareDangerSignsCounselling}
                      name="cordCareDangerSignsCounselling"
                    >
                      <optgroup label="cordCareDangerSignsCounselling">
                        <option selected></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize " style={fontFamilyNunito}>
                      Outcome Status:{" "}
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={outcomeStatus}
                      name="outcomeStatus"
                    >
                      <optgroup label="outcomeStatus">
                        <option selected></option>
                        <option value="Healthy">Healthy</option>
                        <option value="Discharged and Healthy">
                          Discharged and healthy
                        </option>
                        <option value="Died">Died</option>
                        <option value="Referred to NICU">
                          Referred to NICU
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-12">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading == false ? (
                      <span>Submit</span>
                    ) : (
                      <span>Loading</span>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default TreatmentCounselling;
